if (!customElements.get('section-local-storage')) {
    customElements.define(
      'section-local-storage',
      class sectionLocalStorage extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('.i-agree-terms');
          this.check = this.querySelector('.check-agree');
          this.messageError = this.querySelector('.message-error');
          this.contentPage = this.querySelector('.container-terms-page');
          this.containerForm = this.querySelector('.container-form');

          if(this.button){
            this.button.addEventListener('click', e => {
                e.preventDefault();
                if(this.check && this.check.checked){
                    this.messageError.classList.add('hidden');
                    this.contentPage.classList.add('hidden');
                    this.containerForm.classList.remove('hidden');
                }else {
                    this.messageError.classList.remove('hidden');
                }
            })
          }
        }
      },
    );
  }
  